import { render, staticRenderFns } from "./InactiveChannelsToggleCmp.vue?vue&type=template&id=4f9d9481&scoped=true&"
import script from "./InactiveChannelsToggleCmp.vue?vue&type=script&lang=js&"
export * from "./InactiveChannelsToggleCmp.vue?vue&type=script&lang=js&"
import style0 from "./InactiveChannelsToggleCmp.vue?vue&type=style&index=0&id=4f9d9481&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9d9481",
  null
  
)

export default component.exports